module.exports = __webpack_public_path__ + "img/901376227.7cb39ca3.png";